import styled from 'styled-components';

interface IProps {
  isDragging: boolean;
  draggableStyle: any;
  itemHeight?: number;
}

export const DraggableItemStyled = styled.div<IProps>`
  user-select: none;

  ${p => p.draggableStyle}

  ${p =>
    p.itemHeight && p.itemHeight > 0 ? { height: p.itemHeight } : { 'min-height': p.itemHeight }}
`;
